import { render } from "./TestPermissions.vue?vue&type=template&id=37f08f8a&scoped=true"
import script from "./TestPermissions.vue?vue&type=script&lang=js"
export * from "./TestPermissions.vue?vue&type=script&lang=js"

import "./TestPermissions.vue?vue&type=style&index=0&id=37f08f8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37f08f8a"]])

export default __exports__